import { FontAwesomeIcon as BaseFontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { cva } from "class-variance-authority"
import PropTypes from "prop-types"
import { forwardRef } from "react"

import { cn } from "styles/utils"

const iconVariants = cva(
  "inline-block overflow-visible align-middle text-[length:inherit]",
  {
    defaultVariants: {
      flip: false,
      spin: false,
    },
    variants: {
      flip: {
        both: "-scale-1",
        false: null,
        horizontal: "-scale-x-1",
        vertical: "-scale-y-1",
      },
      spin: {
        false: null,
        true: "animate-spin",
      },
    },
  }
)

const FontAwesomeIcon = forwardRef(
  ({ className, flip = false, spin = false, ...props }, ref) => (
    <BaseFontAwesomeIcon
      className={cn(iconVariants({ className, flip, spin }))}
      ref={ref}
      {...props}
    />
  )
)

FontAwesomeIcon.displayName = "FontAwesomeIcon"

FontAwesomeIcon.propTypes = {
  className: PropTypes.string,
  flip: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.oneOf(["both", "horizontal", "vertical"]),
  ]),
  spin: PropTypes.bool,
}

export default FontAwesomeIcon
